var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 63,
    viewBox: "0 0 64 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_175_1974)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.945312,
    y: 30,
    width: 44,
    height: 44,
    rx: 22,
    transform: "rotate(-41.5327 0.945312 30)",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.49988,
    y: 30.0336,
    width: 43.2143,
    height: 43.2143,
    rx: 21.6071,
    transform: "rotate(-41.5327 1.49988 30.0336)",
    stroke: "#EAECF0",
    strokeWidth: 0.785714
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8843 35.5285L36.1187 28.235M36.1187 28.235L28.3547 27.7646M36.1187 28.235L35.6482 35.9989",
    stroke: "#667085",
    strokeWidth: 1.57143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_175_1974",
    x: -5.3404,
    y: -5.45979,
    width: 74.683,
    height: 74.6829,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3.14286
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_175_1974"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_175_1974",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.b2b4418806eac4ac2abfc87ae2090084.svg";
export { ForwardRef as ReactComponent };